import { render, staticRenderFns } from "./SendOrEditMonitoramento.vue?vue&type=template&id=01308ab1&lang=pug"
import script from "./SendOrEditMonitoramento.vue?vue&type=script&lang=js"
export * from "./SendOrEditMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./SendOrEditMonitoramento.vue?vue&type=style&index=0&id=01308ab1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports